import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=7958ace3&"
import script from "./Telegram.vue?vue&type=script&lang=js&"
export * from "./Telegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports